//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ApiBaseClass {
  protected getBaseUrl = (defaultUrl: string, baseUrl: string | undefined) => {
    return process.env.REACT_APP_API_BASE_URL || defaultUrl;
  };
}

export class NotificationsAPI extends ApiBaseClass {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("https://api-development.mybasepay.com", baseUrl);
    }

    /**
     * Send admin notifications
     * @param body (optional) 
     * @return Success
     */
    sendBackofficeAdminNotification(body: BackofficeAdminNotificationModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notification/backoffice/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendBackofficeAdminNotification(_response);
        });
    }

    protected processSendBackofficeAdminNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Send marketplace admin notifications
     * @param body (optional) 
     * @return Success
     */
    sendMPAdminNotifications(body: MarketplaceAdminNotificationModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/notification/marketplace/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMPAdminNotifications(_response);
        });
    }

    protected processSendMPAdminNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface BackofficeAdminNotificationModel {
    inAppNotification?: BackofficeInAppNotificationModel;
    emailNotification?: BackofficeEmailNotificationModel;
}

export interface BackofficeEmailNotificationModel {
    recipientsEmails?: string[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
}

export interface BackofficeInAppNotificationModel {
    recipientsIds?: string[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
}

export interface MarketplaceAdminNotificationModel {
    inAppNotification?: MarketplaceInAppNotificationModel;
    emailNotification?: MarketplaceEmailNotificationModel;
}

export interface MarketplaceEmailNotificationModel {
    recipientsEmails?: string[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
}

export interface MarketplaceInAppNotificationModel {
    recipientsIds?: string[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
}

export interface NotifyDetailsAssignmentEndDaysNotifyModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
    days?: number;
}

export interface NotifyDetailsAssignmentModel {
    assignmentId?: string;
    assignmentKey?: string | undefined;
}

export interface NotifyDetailsCompanyModel {
    companyId?: string;
}

export interface NotifyDetailsCustomerModel {
    clientId?: string;
    customerKey?: string | undefined;
}

export interface NotifyDetailsJobAssignedModel {
    jobId?: string;
}

export interface NotifyDetailsJobCandidateInterviewModel {
    jobCandidateId?: string;
    memberId?: string;
    memberCompanyId?: string;
    memberProfileType?: number | undefined;
    memberCompanyName?: string | undefined;
    jobId?: string;
    candidateId?: string;
}

export interface NotifyDetailsJobCandidateMatchModel {
    jobId?: string;
}

export interface NotifyDetailsJobCandidateModel {
    jobCandidateId?: string;
    jobId?: string;
    candidateId?: string;
}

export interface NotifyDetailsPartnerModel {
    partnerId?: string;
}

export interface NotifyDetailsUserModel {
    userId?: string;
    memberKey?: string | undefined;
}

export interface NotifyDetailsWorkerModel {
    workerId?: string;
    workerKey?: string | undefined;
}

export interface NotifyInstantDetailsModel {
    entityKey?: string | undefined;
    workerName?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}